import React from 'react';
import { useHistory } from 'react-router-dom';

import { Container, MenuContainer } from './MobileMenu.styled';
import { NAV_ITEMS, MENU_ITEMS } from './constants';

const MobileMenu = ({ user }) => {
  const history = useHistory();

  const renderItem = (item) => {
    if (item.type === 'divider') {
      return <div key={item.key} className="divider" />;
    }

    return (
      <div className="menu-item-wrapper">
        {item.external ? (
          <div
            className="account-item w-full h-full"
            key={item.key}
            onClick={() => window.open(item.path, '_blank')}
          >
            {item.label}
          </div>
        ) : (
          <div
            className="account-item w-full h-full"
            key={item.key}
            onClick={() => history.push(item.path)}
          >
            {item.label}
          </div>
        )}
      </div>
    );
  };

  return (
    <Container>
      <div className="header p-4 mb-5 flex flex-col items-center justify-center">
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.2546 15.5055C17.778 14.439 17.0863 13.4702 16.2182 12.6531C15.3526 11.8337 14.3274 11.1804 13.1989 10.7293C13.1888 10.7245 13.1787 10.7221 13.1686 10.7173C14.7427 9.64322 15.7659 7.89359 15.7659 5.9196C15.7659 2.6495 12.9614 0 9.5 0C6.03859 0 3.23408 2.6495 3.23408 5.9196C3.23408 7.89359 4.25735 9.64322 5.83141 10.7197C5.8213 10.7245 5.81119 10.7269 5.80109 10.7317C4.66918 11.1828 3.6535 11.8296 2.78183 12.6555C1.91448 13.4732 1.22294 14.4418 0.745404 15.5079C0.276274 16.5516 0.0232621 17.6706 6.31796e-05 18.8043C-0.000611177 18.8297 0.00411865 18.8551 0.0139741 18.8788C0.0238295 18.9025 0.0386111 18.9242 0.0574479 18.9424C0.0762846 18.9606 0.0987954 18.9751 0.123654 18.985C0.148512 18.9949 0.175215 19 0.202189 19H1.71814C1.82931 19 1.91774 18.9165 1.92026 18.8138C1.97079 16.9711 2.75403 15.2454 4.1386 13.9373C5.57117 12.5839 7.47368 11.8392 9.5 11.8392C11.5263 11.8392 13.4288 12.5839 14.8614 13.9373C16.246 15.2454 17.0292 16.9711 17.0797 18.8138C17.0823 18.9188 17.1707 19 17.2819 19H18.7978C18.8248 19 18.8515 18.9949 18.8763 18.985C18.9012 18.9751 18.9237 18.9606 18.9426 18.9424C18.9614 18.9242 18.9762 18.9025 18.986 18.8788C18.9959 18.8551 19.0006 18.8297 18.9999 18.8043C18.9747 17.6633 18.7245 16.5534 18.2546 15.5055ZM9.5 10.0251C8.3403 10.0251 7.24882 9.59786 6.42768 8.82211C5.60654 8.04636 5.15428 7.0152 5.15428 5.9196C5.15428 4.824 5.60654 3.79284 6.42768 3.01709C7.24882 2.24133 8.3403 1.81407 9.5 1.81407C10.6597 1.81407 11.7512 2.24133 12.5723 3.01709C13.3935 3.79284 13.8457 4.824 13.8457 5.9196C13.8457 7.0152 13.3935 8.04636 12.5723 8.82211C11.7512 9.59786 10.6597 10.0251 9.5 10.0251Z"
            fill="#E8B12C"
          />
        </svg>
        <span className="name text-primary text-base font-semibold mt-2">
          {user.name}
        </span>
      </div>
      <MenuContainer>
        {NAV_ITEMS.map((item) => renderItem(item))}
        {MENU_ITEMS.map((item) => renderItem(item))}
      </MenuContainer>
    </Container>
  );
};

export default MobileMenu;
